module.exports = __webpack_public_path__ + "img/IMG_9001.d89a1c95.jpg";